import React, { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthProvider";
const Header = ({ onclick }) => {
  const userName = (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).fullName).substring(0, 1).toUpperCase();
  const UserFullName = (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).fullName);

  const { logOut } = useAuth();
  useEffect(() => {
    // Get references to the icons
    var toggleOffIcon = document.getElementById("toggle_off_icon");
    var toggleOnIcon = document.getElementById("toggle_on_icon");

    // Function to toggle the icons
    function toggleContent() {
      // Toggle the display property of the icons
      toggleOffIcon.style.display = toggleOffIcon.style.display === "none" ? "inline-block" : "none";
      toggleOnIcon.style.display = toggleOnIcon.style.display === "none" ? "inline-block" : "none";
    }

    // Add event listener to the button
    var toggleButton = document.getElementById("toggle_sidebar");
    toggleButton.addEventListener("click", toggleContent);

    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      toggleButton.removeEventListener("click", toggleContent);
      console.log("Component will unmount");
    };
  }, []);

  useEffect(() => {
    // Effect for cleanup
    return () => {
      console.log("Component will unmount");
      // Any additional cleanup code goes here
    };
  }, []);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    logOut();
  };

  return (
    <header id="main_header" className="bg-white border-bottom border-light-subtle py-2">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col">
            <span id="toggle_sidebar" onClick={onclick} className="fs-22">
              <i className="bi bi-toggle-off" id="toggle_off_icon" style={{ display: "none" }}></i> <i className="bi bi-toggle-on" id="toggle_on_icon"></i>
            </span>
          </div>
          <div className="col-7 col-lg-6">
            <div className="  rounded rounde border border-light-subtle">
              <div className="input-group">
                <input
                  type="search"
                  placeholder="Search Capacity"
                  aria-describedby="button-addon1"
                  className="form-control border-0 bg-light rounded rounded-end-0"
                />
                <div className="input-group-append bg-success-subtle">
                  <button id="button-addon1" type="submit" className="btn btn-link text-teal px-3">
                    <i className="bi bi-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="d-flex justify-content-end align-items-center gap-3">
              <a href="#" className="fs-22">
                <i className="bi bi-bell"></i>
              </a>
              <div className="myprofile bg-primary rounded-circle  text-white dropdown">
                {/* <div className="dropdown"> */}
                <button className="btn btn-success  myprofile rounded-circle" type="button" id="dropdownMenuButton" onMouseOver={toggleDropdown}>
                  {userName}
                </button>
                <ul
                  className={`dropdown-menu${isDropdownOpen ? " show" : ""}`}
                  aria-labelledby="dropdownMenuButton"
                  style={{ position: "absolute", right: 0, top: "100%", zIndex: 2000 }}
                >
                  <li><a className="dropdown-item" href="#">{UserFullName}</a></li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Settings
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => handleLogout()}>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
